<template>
  <div class="">
    <div class="flex flex-col xl:flex-row">
      <div class="px-2 sm:px-0 xl:pr-3 w-full flex-shrink">
        <div class='pt-5 flex flex-col md:flex-row justify-between items-end md:space-x-2 xl:max-w-6xl w-full mb-4'>
          <div class="w-full lg:w-2/3">
            <p class="text-3xl font-light mb-2">Entry Types</p>
            <multiselect class="" v-model="eventShowType" @input="selectEntryType" :options="eventShowTypes" :multiple="false" :close-on-select="true" :clear-on-select="true" :preserve-search="true" placeholder="Select a Entry Type" label="label" :preselect-first="false" :custom-label="(option) => {return `${option.group_type} ~ ${option.label}`}" :hideSelected="false">
              <template slot="singleLabel" slot-scope="props">
                {{ `${props.option.group_type} ~ ${props.option.label}`}}
              </template>
              <div slot="option" slot-scope="props" class="flex items-center">
                <template v-if="props.option.status !== 'ADMIN'">
                  <span class="w-16 mr-2 text-center inline-flex items-center rounded-full bg-green-100 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset border border-green-600 border-opacity-25">ACTIVE</span>
                </template>
                <template v-else>
                  <span class="w-16 mr-2 text-center inline-flex items-center rounded-full bg-red-100 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset border border-red-600 border-opacity-25">ADMIN</span>
                </template>
                {{ `${props.option.group_type} ~ ${props.option.label}`}}
              </div>
            </multiselect>
          </div>
          <div class=" mt-2 md:mt-0 w-full md:w-auto">
            <button v-if="isSupportUser" class="btn btn-green w-full md:w-auto" @click="addNewEntryTypeClicked">New Entry Type</button>
          </div>
        </div>
        <div v-if="eventShowType" class="w-full flex-1" >
          <entry-type-config :eventShowType="eventShowType" :entryFields="entryFields" @deleted="eventShowType = null"/>
        </div>
      </div>
      <div class="px-2 sm:px-0 xl:w-96 xl:border-l xl:border-r xl:border-b xl:flex-shrink-0 rounded-b max-w-xl">
        <div class="xl:sticky xl:top-0">
          <div title="Preview New Entry Dropdown" class="bg-gray-200 border " :startsOpen="true">
            <div slot="title" class="p-2 border-b border-t bg-gray-200 flex justify-between items-center w-full">
              <p class="text-base font-semibold leading-6 text-gray-900">Preview New Entry Dropdown</p>
            </div>
            <div slot="expandable" class="bg-white p-2.5">
              <div class="mt flow-root">
                <p class="text-base">Click the blue "New Entry" button below to preview how the entry types are grouped and how they will appear for your exhibitors. </p>
                <!--<p class="mt-1.5 text-sm"><span class="font-bold">Group Setting: </span>Is the category that combines different Entry Types together to help organize them.</p>
                <p class="mt-1.5 text-sm"><span class="font-bold">Name/Label Setting: </span>The unique label for each entry type to help exhibitors choose the correct shows they are entering.</p>-->
                <entryList class="my-4" :event="{'show_types': eventShowTypesSorted}" :entryGroup="{}" listType="preview" :isAdmin="!viewShowEntryTypeAsExhibitor"/>
                <div class="space-y-5">
                  <div class="relative flex items-start">
                    <div class="flex h-6 items-center">
                      <input v-model="viewShowEntryTypeAsExhibitor" id="comments" aria-describedby="comments-description" name="comments" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600">
                    </div>
                    <div class="ml-3 text-sm">
                      <label for="comments" class="font-medium text-gray-900 mr-1">View as exhibitor?</label>
                      <span id="comments-description" class="text-gray-700 text-xs"><span class="sr-only">View as exhibitor? </span>Check this box to view as the exhibitor, leave it unchecked to view as an admin.</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <template v-if="eventShowType">
            <div class="p-2 text-center bg-gray-700 text-white">
              <p class="text-lg ">Selected Entry Type Details</p>
            </div>
            <expandable title="Shows" class="bg-gray-200">
              <div slot="title" class="p-2 border-b border-t bg-gray-200 flex justify-between items-center w-full">
                <p class="text-base font-semibold leading-6 text-gray-900">Shows ({{ eventShowTypeShows.length }})</p>
              </div>
              <div slot="expandable" class="bg-white p-2.5">
                <p class="text-base">These are the shows that can be entered using this Entry Type.</p>
                <div class="mt-2 flow-root">
                  <ul role="list" class="text-right">
                    <template v-for="(s, si) in eventShowTypeShows">
                      <li :key="si" class="text-base flex flex-wrap items-center justify-between py-1 sm:flex-nowrap">
                        {{ s.name }}
                      </li>
                    </template>
                  </ul>
                </div>
              </div>
            </expandable>
            <expandable title="ClassList" class="bg-gray-200">
              <div slot="title" class="p-2 border-b border-t bg-gray-200 flex justify-between items-center w-full">
                <p class="text-base font-semibold leading-6 text-gray-900">Class List</p>
              </div>
              <div slot="expandable" class="bg-white p-2.5">
                <div class="w-full bg-gray-200 p-1.5 rounded mb-2.5">
                  <label for="class_list" class="block flex items-center text-sm font-medium leading-6 text-gray-900">Current Class List
                    <span v-if="!isSuperUser">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="ml-1 w-3 h-3">
                        <path fill-rule="evenodd" d="M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z" clip-rule="evenodd" />
                      </svg>
                    </span>
                  </label>
                    <v-select
                      class="bg-white rounded py-1 w-full text-xs bg-gray-200"
                      v-model="eventShowType.class_list_id"
                      :options="adminData.class_configurations"
                      label="identifier"
                      :reduce="option => option.class_configuration_id"
                      :clearable="false"
                      :disabled="!isSuperUser"
                      @input="saveEventShowType"
                    >
                    </v-select>
                </div>
                <div v-if="eventShowTypeClassConfiguration.class_calc === 'age'" class="mb-2">
                  <p class="">Base Date:
                    <span class="font-semibold" v-if="eventShowTypeClassConfiguration.base_date_day_of_show"> Day of Show</span>
                    <span class="font-semibold" v-else>{{ formatDate(eventShowTypeClassConfiguration.base_date) }}</span>
                  </p>
                </div>
                <view-class-list :classList="eventShowTypeClassList"/>
              </div>
            </expandable>
          </template>
        </div>
      </div>
    </div>

   <b-modal ref="newEntryType" title="New Entry Type" hide-footer>
      <div>
        <label for="GROUP" class="block text-base font-medium leading-6 text-gray-900">Label</label>
        <div class="relative mt-2">
          <input type="text" name="name" id="name" class="rounded-sm text-xl w-72 peer block border-0 bg-gray-200 px-2 py-1.5 text-gray-900 focus:ring-0 sm:leading-6" placeholder="New Group" v-model="newEntryType.label">
        </div>
      </div>
      <div class="mt-2">
        <label for="GROUP" class="block text-base font-medium leading-6 text-gray-900">Group</label>
        <div class="relative mt-2">
          <input type="text" name="name" id="name" class="rounded-sm text-xl w-72 peer block border-0 bg-gray-200 px-2 py-1.5 text-gray-900 focus:ring-0 sm:leading-6" placeholder="New Group" v-model="newEntryType.group_type">
        </div>
      </div>
      <div class="flex justify-end space-x-3 items-center">
        <button @click="saveNewEntryType" class="btn btn-green">Add</button>
        <button @click="() => { $refs.newEntryType.hide(); newEntryType = {}}" class="btn-xs btn-red-outline">Cancel</button>
      </div>
    </b-modal>

  </div>
</template>

<script>
import EntryList from '@/components/EntryList.vue'

import ViewClassList from '@/components/admin/showEntryTypes/ViewClassList.vue'
import Expandable from '@/components/Expandable'
import EntryTypeConfig from '@/components/admin/showEntryTypes/EntryTypeConfig.vue'

export default {
  components: {
    ViewClassList,
    Expandable,
    EntryList,
    EntryTypeConfig
  },
  data () {
    return {
      eventShowType: null,
      selectedEntryField: {},
      entryFields: [],
      originalEntryFields: [],
      statusOptions: [
        {label: 'Admin Only', value: 'ADMIN'},
        {label: 'Entries Active', value: null}
      ],
      newEntryType: {},
      newGroup: null,
      addedGroups: [],
      exhibitorFields: [
        {
          'model': 'date_of_birth',
          'label': 'Date of Birth',
          'type': 'DATE',
          'options': null,
          'notes': null
        },
        {
          'model': 'club',
          'label': 'Club',
          'type': 'TEXT',
          'options': null,
          'notes': null
        },
        {
          'model': '4h_club',
          'label': '4-H Club',
          'type': 'TEXT',
          'options': null,
          'notes': null
        },
        {
          'model': 'ffa_chapter',
          'label': 'FFA Chapter',
          'type': 'TEXT',
          'options': null,
          'notes': null
        },
        {
          'model': 'county',
          'label': 'County',
          'type': 'TEXT',
          'options': null,
          'notes': null
        }
      ],
      fieldTypes: [
        {
          value: 'input:text',
          label: 'Text',
          description: 'Provide a text field for exhibitors to input the info on their entry.'
        },
        {
          value: 'input:number',
          label: 'Number',
          description: 'Provide a number box for exhibtiors to input the info on their entry.'
        },
        {
          label: 'Date',
          value: 'input:date',
          description: 'Provide a date picker for exhibtiors to input the info on their entry.'
        },
        {
          value: 'checkbox',
          label: 'Checkbox',
          description: 'Provide a checbox for exhibtiors to check if applicable.'
        },
        {
          label: 'Select',
          value: 'select',
          description: 'Provide a dropdown box for exhibitors to select their answer from a list of options.'
        }
      ],
      newFieldType: null,
      viewShowEntryTypeAsExhibitor: true
    }
  },
  methods: {
    formatDate: function (date) {
      if (!date) return ''
      return this.Localized.formatDate(date, this.event.location_details.country)
    },
    selectEntryType (showType) {
      // Update Entry Fields
      this.eventShowType = JSON.parse(JSON.stringify(showType))
      if (this.eventShowTypeSpecies) {
        this.$store.state.apiInstance.get(`${process.env.VUE_APP_ROOT_API}/getSpeciesTypeEntryFields/${this.eventShowTypeSpecies}`)
          .then(response => {
            this.entryFields = response.data.data
          })
      }
    },
    saveEventShowType: function () {
      this.eventShowType.name = 'event_show_types'
      if (!this.eventShowType.event_show_type_id) {
        this.$store.dispatch('addData', this.eventShowType)
          .then(response => {
            this.notie.alert({
              type: 1,
              text: `Entry Type Successfully Saved`
            })
            this.$emit('saved')
          })
          .catch(() => {
            // this.$honeybadger.notify(error)
            this.notie.alert({
              type: 3,
              text: `Error creating Entry Type, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
            })
          })
      } else {
        this.$store.dispatch('updateData', this.eventShowType)
          .then(response => {
            this.notie.alert({
              type: 1,
              text: `Entry Type Updated`
            })
            this.$emit('saved')
          })
          .catch(() => {
            this.notie.alert({
              type: 3,
              text: `Error Updating Entry Type, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
            })
          })
      }
    },
    addNewEntryTypeClicked () {
      this.newEntryType = {
        label: '',
        group_type: '',
        status: 'ACTIVE',
        class_calc: {},
        entry_details: [
          {
            fields: []
          }
        ]
      }
      this.$refs.newEntryType.show()
    },
    saveNewEntryType () {
      if (!this.newEntryType.label) {
        this.notie.alert({
          type: 3,
          text: `Please enter a label for the new Entry Type`
        })
        return
      }
      if (!this.newEntryType.group_type) {
        this.notie.alert({
          type: 3,
          text: `Please enter a group for the new Entry Type`
        })
        return
      }

      this.newEntryType.group_type = this.newEntryType.group_type.toUpperCase()
      this.newEntryType.name = 'event_show_types'
      this.newEntryType.identifier = this.newEntryType.label
      this.$store.dispatch('addData', this.newEntryType)
        .then(response => {
          this.notie.alert({
            type: 1,
            text: `Entry Type Updated`
          })
          this.newEntryType.event_show_type_id = response.data.data.event_show_type_id
          this.$emit('saved')
          this.$refs.newEntryType.hide()
          this.eventShowType = this.eventShowTypes.filter(et => et.event_show_type_id === this.newEntryType.event_show_type_id)[0]
        })
        .catch(() => {
          this.notie.alert({
            type: 3,
            text: `Error Updating Entry Type, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
          })
        })
    }
  },
  computed: {
    currentUser () {
      return this.$store.state.user
    },
    isSuperUser () {
      return this.currentUser.user_id === 'Clo1Va5v4pNuvE1TqHPNeKWFGay2'
    },
    isSupportUser () {
      return this.currentUser.role === 'ADMIN' || this.isSuperUser
    },
    adminData () {
      return this.$store.state.admin.adminData
    },
    eventShowTypes () {
      return this.adminData.event_show_types
    },
    eventShowTypesSorted () {
      let showTypes = JSON.parse(JSON.stringify(this.eventShowTypes))
      return showTypes.sort((a, b) => {
        if (a.group_type < b.group_type) {
          return -1
        }
        if (a.group_type > b.group_type) {
          return 1
        }
        if (a.label < b.label) {
          return -1
        }
        if (a.label > b.label) {
          return 1
        }

        return 0
      })
    },
    event () {
      return this.adminData.event
    },
    eventShowTypeShows () {
      if (this.eventShowType) {
        return this.adminData.event.shows.filter(s => this.eventShowType.event_show_type_id === s.entry_details_id)
      }
      return []
    },
    eventShowTypeSpecies () {
      if (this.eventShowTypeShows.length > 0) {
        return this.eventShowTypeShows[0].species
      } else {
        return null
      }
    },
    eventShowTypeClassList () {
      let est = this.adminData.event.show_types.filter(st => st.class_list_id === this.eventShowType.class_list_id)[0]
      if (est) {
        return est.class_list
      } else {
        return null
      }
    },
    eventShowTypeClassConfiguration () {
      let configs = this.adminData.class_configurations.filter(c => c.class_configuration_id === this.eventShowType.class_list_id)
      if (configs.length) {
        return configs[0].config
      } else {
        return {}
      }
    }
  }
}
</script>

<style>
.v-select .dropdown-menu {
  display:block;
}
.tooltip {
  text-align: cent_er;
}
</style>
